if (!customElements.get('sort-select')) {
  class SortSelect extends HTMLElement {
    constructor() {
      super();

      this.select = this.querySelector('select');
    }

    connectedCallback() {
      this.select.addEventListener('change', function (event) {
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', event.target.value);
        window.location.search = params;
      });
    }
  }
  customElements.define('sort-select', SortSelect);
}
